"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var useTable_1 = __importDefault(require("../../../hooks/useTable"));
var API_1 = require("../../../middleware/API");
var transformClinicAvailability_1 = __importDefault(require("../../../middleware/transformClinicAvailability"));
var transformWeekDaysObjectToArray_1 = __importDefault(require("../../../middleware/transformWeekDaysObjectToArray"));
var loginState_1 = require("../../../types/loginState");
var Loading_1 = __importDefault(require("../../atoms/Loading/Loading"));
var TablePagination_1 = __importDefault(require("../../molecules/TablePagination/TablePagination"));
var TableView_styles_1 = __importDefault(require("../../styled/TableView.styles"));
var AgendaOverview_1 = require("../AgendaOverview/AgendaOverview");
var AvailabilityOverview_styles_1 = __importDefault(require("./AvailabilityOverview.styles"));
var rowsPerPage = 8;
var AvailabilityOverview = function (_a) {
    var loggedIn = _a.loggedIn, username = _a.username;
    var _b = react_1.useState(1), page = _b[0], setPage = _b[1];
    var _c = react_1.useState(true), isLoading = _c[0], setIsLoading = _c[1];
    var _d = react_1.useState([]), clinics = _d[0], setClinics = _d[1];
    var _e = react_1.useState(), notAvailableDays = _e[0], setNotAvailableDays = _e[1];
    var _f = react_1.useState(), notAvailableRanges = _f[0], setNotAvailableRanges = _f[1];
    var _g = useTable_1.default(clinics, page, rowsPerPage), slice = _g.slice, range = _g.range;
    react_1.useEffect(function () {
        var getData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, API_1.getAvailabilityData()];
                    case 1:
                        data = _a.sent();
                        if (!(data instanceof Error)) {
                            if (data.weekdays) {
                                setNotAvailableDays(transformWeekDaysObjectToArray_1.default(data.weekdays));
                            }
                            if (data.unavailable_periods) {
                                setNotAvailableRanges(data.unavailable_periods);
                            }
                            if (data.clinic_availability) {
                                setClinics(transformClinicAvailability_1.default(data.clinic_availability));
                            }
                        }
                        setIsLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        getData();
    }, []);
    if (loggedIn !== loginState_1.LOGGEDIN) {
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: "/login" });
    }
    if (isLoading) {
        return react_1.default.createElement(Loading_1.default, null);
    }
    return (react_1.default.createElement(AvailabilityOverview_styles_1.default, null,
        react_1.default.createElement("div", { className: "container" },
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: "header" },
                    react_1.default.createElement("h1", { className: "title" }, "Beschikbaarheid"),
                    react_1.default.createElement("p", { className: "description" }, "Geef de beschikbaarheid van jou en je schoolsport clinics aan."))),
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: "section sectionSplit" },
                    react_1.default.createElement("h2", { className: "sectionTitle" }, "Vrije dagen"),
                    react_1.default.createElement("div", { className: "sectionInner" },
                        react_1.default.createElement("p", null, "Copy ntb. Dagen waarop je structureel niet beschikbaar bent"),
                        react_1.default.createElement("b", null, "Dagen niet beschikbaar"),
                        react_1.default.createElement("p", null,
                            react_1.default.createElement("svg", { className: "icon icon--calendar" },
                                react_1.default.createElement("use", { xmlnsXlink: "http://www.w3.org/1999/xlink", xlinkHref: "/dist/svg/sprite.min.svg#calendar" })),
                            ' ',
                            notAvailableDays && notAvailableDays.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement("span", { className: "dateRange" }, notAvailableDays.join(', ')))),
                            (!notAvailableDays || notAvailableDays.length === 0) && (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement("span", { className: "dateRange" }, "Nog geen data opgegeven"))),
                            react_1.default.createElement("a", { href: "/availability-days", className: "edit" }, "Aanpassen")))),
                react_1.default.createElement("div", { className: "section sectionSplit" },
                    react_1.default.createElement("h2", { className: "sectionTitle" }, "Niet beschikbaar"),
                    react_1.default.createElement("div", { className: "sectionInner" },
                        react_1.default.createElement("p", null, "Copy ntb. Wanneer je niet beschikbaar bent om een clinic te geven op deze specifieke data. bijv. door vakantie."),
                        react_1.default.createElement("b", { className: "red" }, "Niet beschikbaar"),
                        react_1.default.createElement("p", null,
                            react_1.default.createElement("svg", { className: "icon icon--calendar" },
                                react_1.default.createElement("use", { xmlnsXlink: "http://www.w3.org/1999/xlink", xlinkHref: "/dist/svg/sprite.min.svg#calendar" })),
                            notAvailableRanges &&
                                notAvailableRanges.length > 0 &&
                                notAvailableRanges.map(function (item) { return (react_1.default.createElement(react_1.default.Fragment, null,
                                    react_1.default.createElement("span", { key: item.id, className: "dateRange" },
                                        AgendaOverview_1.formatDate(item.start_date),
                                        " t/m ",
                                        AgendaOverview_1.formatDate(item.end_date)))); }),
                            !notAvailableRanges && (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement("span", { className: "dateRange" }, "Nog geen data opgegeven"))),
                            react_1.default.createElement("a", { href: "/availability-ranges", className: "edit" }, "Aanpassen"))))),
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: "section" },
                    react_1.default.createElement("h2", { className: "sectionTitle" }, "Beschikbaarheid per clinic aanpassen"),
                    slice.length && slice.length > 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(TableView_styles_1.default, null,
                            react_1.default.createElement("table", { className: "table" },
                                react_1.default.createElement("thead", { className: "table-head" },
                                    react_1.default.createElement("tr", { className: "table-row" },
                                        react_1.default.createElement("th", null, "Naam clinic"),
                                        react_1.default.createElement("th", null, "Sport"),
                                        react_1.default.createElement("th", null, "Soort clinic"),
                                        react_1.default.createElement("th", null, "Datum"))),
                                react_1.default.createElement("tbody", { className: "table-body" }, slice.map(function (item, index) { return (react_1.default.createElement("tr", { key: item.id, className: "table-row" },
                                    react_1.default.createElement("td", null, item.name),
                                    react_1.default.createElement("td", null, item.sport),
                                    react_1.default.createElement("td", null, item.type),
                                    react_1.default.createElement("td", null,
                                        AgendaOverview_1.formatDate(item.start_date),
                                        " t/m ",
                                        AgendaOverview_1.formatDate(item.end_date),
                                        react_1.default.createElement(react_router_dom_1.Link, { to: "/clinic-availability/" + item.id },
                                            react_1.default.createElement("button", { className: "editBtn" }, "Aanpassen"))))); })))),
                        react_1.default.createElement(TablePagination_1.default, { range: range, slice: slice, setPage: setPage, page: page }))) : (react_1.default.createElement("div", { className: "emptyState" },
                        react_1.default.createElement("p", null, "Er zijn geen clinics ingepland voor komend schooljaar 2022 - 2023"))))))));
};
exports.default = AvailabilityOverview;
